import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["align", "direction", "justify", "gap", "flex", "style", "className", "as", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
/* eslint-disable complexity */
import { getSpacing } from "@faire/web--source/slate/spacing/getSpacing";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import cn from "classnames";
import React from "react";
import { isResponsiveProp } from "../Theme/ResponsiveProp";
// eslint-disable-next-line import/no-unassigned-import
import "./native-styles.css";
export var Flex = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var alignProp = _ref.align,
    directionProp = _ref.direction,
    justifyProp = _ref.justify,
    gapProp = _ref.gap,
    flexProp = _ref.flex,
    styleProp = _ref.style,
    classNameProp = _ref.className,
    asProp = _ref.as,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var vars = {};
  var classNames = [];
  // Gap
  if (isResponsiveProp(gapProp)) {
    vars["--f_flex_gap_mobile"] = getSpacing(gapProp.mobileAndAbove);
    vars["--f_flex_gap_tablet"] = gapProp.tabletAndAbove != null ? getSpacing(gapProp.tabletAndAbove) : vars["--f_flex_gap_mobile"];
    vars["--f_flex_gap_desktop"] = gapProp.desktopAndAbove != null ? getSpacing(gapProp.desktopAndAbove) : vars["--f_flex_gap_tablet"];
    vars["--f_flex_gap_xlarge"] = gapProp.xLargeAndAbove != null ? getSpacing(gapProp.xLargeAndAbove) : vars["--f_flex_gap_desktop"];
    vars["--f_flex_gap_xxlarge"] = gapProp.xxLargeDesktop != null ? getSpacing(gapProp.xxLargeDesktop) : vars["--f_flex_gap_xlarge"];
    classNames.push("f_flex_variable_gap");
  } else if (gapProp != null) {
    vars["--f_flex_gap_mobile"] = getSpacing(gapProp);
    classNames.push("f_flex_single_value_gap");
  }
  // Flex
  if (isResponsiveProp(flexProp)) {
    var _flexProp$mobileAndAb, _flexProp$tabletAndAb, _flexProp$desktopAndA, _flexProp$xLargeAndAb, _flexProp$xxLargeDesk;
    vars["--f_flex_flex_mobile"] = (_flexProp$mobileAndAb = flexProp.mobileAndAbove) === null || _flexProp$mobileAndAb === void 0 ? void 0 : _flexProp$mobileAndAb.toString();
    vars["--f_flex_flex_tablet"] = flexProp.tabletAndAbove != null ? (_flexProp$tabletAndAb = flexProp.tabletAndAbove) === null || _flexProp$tabletAndAb === void 0 ? void 0 : _flexProp$tabletAndAb.toString() : vars["--f_flex_flex_mobile"];
    vars["--f_flex_flex_desktop"] = flexProp.desktopAndAbove != null ? (_flexProp$desktopAndA = flexProp.desktopAndAbove) === null || _flexProp$desktopAndA === void 0 ? void 0 : _flexProp$desktopAndA.toString() : vars["--f_flex_flex_tablet"];
    vars["--f_flex_flex_xlarge"] = flexProp.xLargeAndAbove != null ? (_flexProp$xLargeAndAb = flexProp.xLargeAndAbove) === null || _flexProp$xLargeAndAb === void 0 ? void 0 : _flexProp$xLargeAndAb.toString() : vars["--f_flex_flex_desktop"];
    vars["--f_flex_flex_xxlarge"] = flexProp.xxLargeDesktop != null ? (_flexProp$xxLargeDesk = flexProp.xxLargeDesktop) === null || _flexProp$xxLargeDesk === void 0 ? void 0 : _flexProp$xxLargeDesk.toString() : vars["--f_flex_flex_xlarge"];
    classNames.push("f_flex_variable_flex");
  } else if (flexProp != null) {
    var _parts$, _parts$2;
    var parts = flexProp.toString().split(" ");
    vars["--f_flex_flex_grow"] = parts[0];
    vars["--f_flex_flex_shrink"] = (_parts$ = parts[1]) !== null && _parts$ !== void 0 ? _parts$ : "1";
    vars["--f_flex_flex_basis"] = (_parts$2 = parts[2]) !== null && _parts$2 !== void 0 ? _parts$2 : "0%";
    classNames.push("f_flex_single_value_flex_grow");
    classNames.push("f_flex_single_value_flex_shrink");
    classNames.push("f_flex_single_value_flex_basis");
  }
  // Align
  if (isResponsiveProp(alignProp)) {
    vars["--f_flex_align_mobile"] = alignProp.mobileAndAbove;
    vars["--f_flex_align_tablet"] = alignProp.tabletAndAbove != null ? alignProp.tabletAndAbove : vars["--f_flex_align_mobile"];
    vars["--f_flex_align_desktop"] = alignProp.desktopAndAbove != null ? alignProp.desktopAndAbove : vars["--f_flex_align_tablet"];
    vars["--f_flex_align_xlarge"] = alignProp.xLargeAndAbove != null ? alignProp.xLargeAndAbove : vars["--f_flex_align_desktop"];
    vars["--f_flex_align_xxlarge"] = alignProp.xxLargeDesktop != null ? alignProp.xxLargeDesktop : vars["--f_flex_align_xlarge"];
    classNames.push("f_flex_variable_align");
  } else if (alignProp != null) {
    vars["--f_flex_align_mobile"] = alignProp;
    classNames.push("f_flex_single_value_align");
  }
  // Justify
  if (isResponsiveProp(justifyProp)) {
    vars["--f_flex_justify_mobile"] = justifyProp.mobileAndAbove;
    vars["--f_flex_justify_tablet"] = justifyProp.tabletAndAbove != null ? justifyProp.tabletAndAbove : vars["--f_flex_justify_mobile"];
    vars["--f_flex_justify_desktop"] = justifyProp.desktopAndAbove != null ? justifyProp.desktopAndAbove : vars["--f_flex_justify_tablet"];
    vars["--f_flex_justify_xlarge"] = justifyProp.xLargeAndAbove != null ? justifyProp.xLargeAndAbove : vars["--f_flex_justify_desktop"];
    vars["--f_flex_justify_xxlarge"] = justifyProp.xxLargeDesktop != null ? justifyProp.xxLargeDesktop : vars["--f_flex_justify_xlarge"];
    classNames.push("f_flex_variable_justify");
  } else if (justifyProp != null) {
    vars["--f_flex_justify_mobile"] = justifyProp;
    classNames.push("f_flex_single_value_justify");
  }
  // Direction
  if (isResponsiveProp(directionProp)) {
    vars["--f_flex_direction_mobile"] = directionProp.mobileAndAbove;
    vars["--f_flex_direction_tablet"] = directionProp.tabletAndAbove != null ? directionProp.tabletAndAbove : vars["--f_flex_direction_mobile"];
    vars["--f_flex_direction_desktop"] = directionProp.desktopAndAbove != null ? directionProp.desktopAndAbove : vars["--f_flex_direction_tablet"];
    vars["--f_flex_direction_xlarge"] = directionProp.xLargeAndAbove != null ? directionProp.xLargeAndAbove : vars["--f_flex_direction_desktop"];
    vars["--f_flex_direction_xxlarge"] = directionProp.xxLargeDesktop != null ? directionProp.xxLargeDesktop : vars["--f_flex_direction_xlarge"];
    classNames.push("f_flex_variable_direction");
  } else if (directionProp != null) {
    vars["--f_flex_direction_mobile"] = directionProp;
    classNames.push("f_flex_single_value_direction");
  }
  return /*#__PURE__*/React.createElement(asProp || "div", _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    style: _objectSpread(_objectSpread({}, assignInlineVars(vars)), styleProp),
    className: cn(classNameProp, "f_flex_base", classNames)
  }), children);
});